// extracted by mini-css-extract-plugin
module.exports = {"formatted-message__content--bold":"FormattedMessage_formatted-message__content--bold__GomvN"};